import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/app/web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/web/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { parseString } from 'core/utils/parser';
export var LocalStorageRepository = /*#__PURE__*/function () {
  function LocalStorageRepository() {
    _classCallCheck(this, LocalStorageRepository);
  }

  _createClass(LocalStorageRepository, [{
    key: "get",
    value:
    /**
     * @inheritdoc
     */
    function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", localStorage.getItem(key));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * @inheritdoc
     */

  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, value) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage.setItem(key, parseString(value));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function set(_x2, _x3) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }]);

  return LocalStorageRepository;
}();